var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.0051C22 11.6504 21.8438 11.2856 21.5836 11.0424L14.7746 4.41545C14.4831 4.13173 14.1499 4 13.8168 4C13.0463 4 12.5049 4.53705 12.5049 5.23623C12.5049 5.62128 12.6715 5.92527 12.911 6.16846L15.2743 8.47878L17.9084 10.8296L15.5659 10.708H3.37428C2.5518 10.708 2 11.235 2 12.0051C2 12.7752 2.5518 13.3021 3.37428 13.3021H15.5659L17.9084 13.1704L15.2743 15.5313L12.911 17.8315C12.6715 18.0747 12.5049 18.3787 12.5049 18.7638C12.5049 19.4731 13.0463 20 13.8168 20C14.1499 20 14.4727 19.8683 14.7538 19.5947L21.5836 12.9677C21.8438 12.7144 22 12.3597 22 12.0051Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow-right.8a9db6e240b642c7e945d956d27a89ec.svg";